import { Component, OnInit, ViewEncapsulation, ChangeDetectionStrategy, Input, Injector, NgModule } from '@angular/core';
import { NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';
import { Observable, of, map } from 'rxjs';
import { ContactSummary, ContactUtility, Entity } from '@jms/model';
import { PickerFetch } from '@jms/ui/ui.core.pickers/src/components';
import { PickerBaseComponent } from '@jms/ui/ui.pickers.base';
import { CommonModule } from '@angular/common';
import { NgSelectModule } from '@ng-select/ng-select';
import { PickerItemModule } from '@jms/ui/ui.picker.item';
import { HttpClient } from '@angular/common/http';
import { EntityItemModule } from '../entity.item';

@Component({
  selector: 'timesheet-resource-picker',
  templateUrl: './timesheet.resource.picker.component.html',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    { provide: NG_VALUE_ACCESSOR, useExisting: TimesheetResourcePickerComponent, multi: true }
  ],
  standalone: false
})
export class TimesheetResourcePickerComponent extends PickerBaseComponent implements OnInit {

  @Input() public data: ContactSummary[];
  @Input() public placeholder = '<Resource>';
  @Input() public getAllResources: boolean;

  public data$: Observable<ContactSummary[]>;

  constructor(
    injector: Injector,
    private http: HttpClient
  ) {
    super(injector);
  }

  public async ngOnInit() {

    super.ngOnInit();

    const data$ = this.fetch === PickerFetch.Automatic
      ? this.getResources()
      : of(this.data);

    this.data$ = data$
      .pipe(
        map((items: ContactSummary[]) => {

          return ContactUtility.contactGrouping(items);

        })
      );

  }


  private getResources(): Observable<Entity[]> {
    const baseUrl = '/api/picker/contact/timesheet'

    if (this.getAllResources) {
      return this.http.get<Entity[]>(`${baseUrl}?getAllResources=true&excludeInactive=true`);
    }

    return this.http.get<Entity[]>(`${baseUrl}?excludeInactive=true`);
  }
}


@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    NgSelectModule,
    PickerItemModule,
    EntityItemModule
  ],
  declarations: [
    TimesheetResourcePickerComponent
  ],
  providers: [],
  exports: [
    TimesheetResourcePickerComponent
  ],
})
export class TimesheetResourcePickerModule { }